import {FooterSection, Header,} from './sections';
import "./sections/style.css";
import ReactGA from "react-ga4";
import {useEffect} from 'react';
import {FaLinkedin} from "react-icons/fa";
import SEO from '../../components/common/SEO';
import {breadcrumbSchema} from '../../utils/structuredData';


const Home = () => {
  useEffect(()=>{
    if(process.env.REACT_APP_ENV === "production") {
      ReactGA.initialize("G-ZB9N7T58NE");
      ReactGA.send({ hitType: "pageview", page: "/", title: "About Page" });
    }
  },[])
  
  const breadcrumbs = breadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'About', url: '/about' }
  ]);

  return (
    <div className="min-w-full homePageContainer relative !bg-black">
      <SEO
        title="About CadencePro - AI-Powered Project Planning & Risk Management"
        description="Learn about Cadencepro's mission to revolutionize project management with AI-powered dynamic estimations that adapt to changes in cost, timeline, and scope."
        canonical="/about"
        keywords="about cadencepro, project management software, AI project planning, team collaboration, project estimation tool"
        structuredData={breadcrumbs}
      />
      <Header />
      {/* <Maintenance /> */}
      <section className="bg-black">
        <div className="grid gap-16 py-8 px-4 mx-auto max-w-screen-xl lg:grid-cols-2 lg:py-16 lg:px-6">
          <div className="sm:text-lg text-gray-300">
            <h2 className="mb-10 text-4xl tracking-tight font-extrabold text-white">Why Cadence?</h2>
            <p className="mb-2 md:text-lg text-gray-300">
              Cadencepro emerged from a personal quest for excellence in project execution. While managing large highly performant teams, handling ever changing scope, timeline and resource dependencies became as critical as steering the projects themselves. There was no software tool that would give me dynamic estimations based on cost, timeline and scope changes. That is when I started envisioning Cadencepro.
            </p>
            <p className="mb-2 md:text-lg text-gray-300">

              Cadencepro is not just another tool; it's the embodiment of our quest for excellence in project planning. Born from firsthand experience, it offers dynamic estimations that adapt to changes in cost, timeline, and scope, ensuring that leaders are always a step ahead.
            </p>
            <p className="mb-2 md:text-lg text-gray-300">
              We invite you to discover how Cadencepro can transform your project management approach. Join us in redefining what's possible, and see firsthand the difference that real-time adaptability can make.

            </p>
            {/* <p className="font-light md:text-lg">Working here means you’ll interact with talented professionals, will be challenged to solve difficult problems and think in new and creative ways. Along the way, you may also make some new friends, have a lot of fun and enjoy opportunities.</p> */}
          </div>
          <div>
            <h2 className=" text-4xl tracking-tight font-extrabold text-white mb-10">Our team</h2>
            <div className="flex gap-5 flex-col">
              <div className="flex flex-col items-center pb-8 sm:flex-row bg-gray-900/50 border border-gray-800 rounded-xl p-6 hover:border-gray-700 transition">
                <img className="mx-auto mb-4 w-36 h-36 rounded-full sm:ml-0 sm:mr-6 ring-2 ring-gray-800" src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/Karan.jpeg" alt="Karan Keswani" />
                <div className="text-center sm:text-left">
                  <h3 className="text-xl font-bold tracking-tight text-white">
                    <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/keswanikaran/">Karan Keswani</a>
                  </h3>
                  <span className="text-gray-400">Founder & CEO</span>
                  <p className="mt-2 mb-2 max-w-sm font-light text-gray-400">Entrepreneur, Engineer at heart</p>
                  <ul className="flex justify-center space-x-4 sm:justify-start mt-2">
                    <li>
                      <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/keswanikaran/" className="text-blue-500 hover:text-blue-400">
                        <FaLinkedin />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* TODO: Add Jay's profile */}
              {/* <div className="flex flex-col items-center pb-8 sm:flex-row bg-gray-900/50 border border-gray-800 rounded-xl p-6 hover:border-gray-700 transition">
                <img className="mx-auto mb-4 w-36 h-36 rounded-full sm:ml-0 sm:mr-6 ring-2 ring-gray-800" src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/nitin.jpg" alt="Karan Keswani" />
                <div className="text-center sm:text-left">
                  <h3 className="text-xl font-bold tracking-tight text-white">
                    <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/ntyagi1/">Nitin</a>
                  </h3>
                  <span className="text-gray-400">Founding Engineer</span>
                  <p className="mt-2 mb-2 max-w-sm font-light text-gray-400"></p>
                  <ul className="flex justify-center space-x-4 sm:justify-start mt-2">
                    <li>
                      <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/ntyagi1/" className="text-blue-500 hover:text-blue-400">
                        <FaLinkedin />
                      </a>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <FooterSection />
    </div>
  )
};

export default Home;
